// extracted by mini-css-extract-plugin
export default {"cls1":"VeloRadio-StyledRadio_cls1__3qNVH","cls2":"VeloRadio-StyledRadio_cls2__Ndeez VeloRadio-StyledRadio_cls1__3qNVH"};